import * as React from 'react';
import SalesReportListItem from './SalesReportListItem';
import Section from './Section';
import { SalesReport } from '../sales-report';

const renderItem = (report: SalesReport, index: number) => (
  <SalesReportListItem report={report} key={index} index={index} />
);

interface Props {
  items: SalesReport[];
}

export default function SalesReportsList(props: Props) {
  return (
    <div className="mw8 center">
      <Section title="Recent sales reports">
        {props.items.map(renderItem)}
      </Section>
    </div>
  );
}
